import React, { useState, useEffect } from 'react';
import { detectAnyAdblocker } from 'just-detect-adblock';

const overlayStyle = {
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: '#fff',
  padding: '30px',
  borderRadius: '10px',
  textAlign: 'center',
  maxWidth: '400px',
  width: '80%',
  boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
};

// const buttonStyle = {
//   marginTop: '20px',
//   padding: '10px 20px',
//   backgroundColor: '#007bff',
//   color: '#fff',
//   border: 'none',
//   borderRadius: '5px',
//   cursor: 'pointer',
// };

function AdblockModal() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    detectAnyAdblocker().then((detected) => {
      if (detected) {
        setShow(true);
        document.body.style.overflow = 'hidden'	
      }
    });

    return () => {
      document.body.style.overflow = 'auto'; // 모달 사라질 때 복구
    };
  }, []);

  if (!show) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <h2>애드블록 감지됨</h2>
        <p>
          이 사이트는 광고 수익으로 운영됩니다.<br />
          애드블록을 꺼주시면 감사하겠습니다!
        </p>
        {/* <button style={buttonStyle}>확인</button> */}
      </div>
    </div>
  );
}

export default AdblockModal;
